import { render, staticRenderFns } from "./createOrder.vue?vue&type=template&id=3534c800&scoped=true&"
import script from "./createOrder.vue?vue&type=script&lang=js&"
export * from "./createOrder.vue?vue&type=script&lang=js&"
import style0 from "./createOrder.vue?vue&type=style&index=0&id=3534c800&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3534c800",
  null
  
)

export default component.exports